'use strict';
import React, { PureComponent } from 'react';
import SectorSuperior from './Grilla/SectorSuperior'
import TablaHeader from './Grilla/TablaHeader'
import TablaBody from './Grilla/TablaBody'

class Tabla extends PureComponent {

    constructor(props) {
        super(props);

    }

    render() {
        const { ajusteCargo, expandirRow, rowSeleccionada, destildarTildarCheck, checkConfirmarArray, checkDenegarRestablecerArray, destildarTildarCheckAll, checkConfirmarAll, checkDenegarRestablecerAll, mostrarModalCambiarEstado, objFiltradoBtnVer, totalChecks, user} = this.props;
        
        let classScroll = ajusteCargo && ajusteCargo.length > 15 ? ' confirmadorAjusteCargoScroll' : '';
        let tieneScroll = classScroll ? true : false;
        let ajusteCargoEstado = objFiltradoBtnVer && objFiltradoBtnVer.estado ? objFiltradoBtnVer.estado : "PEND. CONFIRMACIÓN";
        let ajusteCargoMismoUsuario = ajusteCargo.filter(movimiento => movimiento.UsuarioAlta != user[0].Login )
        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12 confirmadorAjusteCargoTable">
                    <SectorSuperior ajusteCargoTotal={ajusteCargo.length} ajusteCargo={ajusteCargo} mostrarModalCambiarEstado={mostrarModalCambiarEstado} totalChecks={totalChecks}/>

                    <table className="noBorder confirmadorAjusteCargoTableHeaderMain confirmadorAjusteCargoTable">
                        <TablaHeader ajusteCargoEstado={ajusteCargoEstado}
                                     tieneScroll={tieneScroll}
                                     destildarTildarCheckAll={destildarTildarCheckAll}
                                     checkConfirmarAll={checkConfirmarAll}
                                     checkDenegarRestablecerAll={checkDenegarRestablecerAll}
                                     ajusteCargo={ajusteCargoMismoUsuario}
                        />
                    </table>
                    <table className={"noBorder confirmadorAjusteCargoTable"}>
                        <TablaBody ajusteCargo={ajusteCargo} 
                                   expandirRow={expandirRow}
                                   rowSeleccionada={rowSeleccionada}
                                   destildarTildarCheck={destildarTildarCheck}
                                   checkConfirmarArray={checkConfirmarArray}
                                   checkDenegarRestablecerArray={checkDenegarRestablecerArray}
                                   tieneScroll={tieneScroll}
                                   classScroll={classScroll}
                                   user={user}
                        />
                    </table>

                </div>
            </div>
        )

    }
}

export default Tabla;